import { Network as CarrierNetwork } from "components/Carrier/components/Network";
import { Network as ShipperNetwork } from "components/Shipper/components/Network";
import { useRoleContext } from "hooks";

export function Network() {
  const { role } = useRoleContext();

  if (role?.type === "CARRIER") {
    return <CarrierNetwork />;
  }
  if (role?.type === "SHIPPER") {
    return <ShipperNetwork />;
  }
  return null;
}
